export function select() {
  const select01 = document.querySelector('.js-select01');
  if(select01) {
    const trigger = select01.querySelector('.js-select01--trigger');
    const panel = select01.querySelector('.js-select01--panel');

    trigger.addEventListener('click', function() {
      this.classList.toggle('is-active');
      panel.classList.toggle('is-active');
      const options = select01.querySelectorAll('.js-select01--option');

      options.forEach(option => {
        option.addEventListener('click', function() {
          const selectTxt = select01.querySelector('.js-select01--select');
          trigger.classList.remove('is-notselected');
          panelClose(options);
          this.classList.add('is-active');
          const dataValue = this.dataset.value;
          selectTxt.innerHTML = dataValue;
        })
      });
    })

    const panelClose = (options) => {
      options.forEach(element => {
        element.classList.remove('is-active');
      });
      trigger.classList.remove('is-active');
      panel.classList.remove('is-active');
    }
  }

  const select02 = document.querySelector('.js-select02');

  if(select02) {
    const trigger = select02.querySelector('.js-select02--trigger');
    const panel = select02.querySelector('.js-select02--panel');

    const panelClose = (array) => {
      array.forEach(element => {
        element.classList.remove('is-active');
      });
      trigger.classList.remove('is-active');
      panel.classList.remove('is-active');
    }

    const optionSelect = () => {
      const options = panel.querySelectorAll('.js-select02--option');
      for (let index = 0; index < options.length; index++) {
        const option = options[index];
        option.addEventListener('click', function() {
          let value = option.dataset.value;
          panelClose(options);
          option.classList.add('is-active');

          const selectTxt = trigger.querySelector('.js-select02--select');
          selectTxt.textContent = value;
        });
      }
    }

    trigger.addEventListener('click', function () {
      this.classList.toggle('is-active');
      panel.classList.toggle('is-active');
      optionSelect();
    });
  }
}